import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useInvoiceContext } from '../InvoiceProvider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import {
  boolean as booleanFormatter,
  date as dateFormatter,
  datetime as datetimeFormatter,
} from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const InvoiceStatusSection = () => {
  const intl = useIntl();
  const { invoice } = useInvoiceContext();
  const { is_paid: isPaid = false, paid_at: paidAt, created_at: billedAt } = invoice || {};

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Property
          label={intl.formatMessage(translations.overview.isPaid)}
          value={booleanFormatter(isPaid)}
        />

        <Property
          label={intl.formatMessage(translations.overview.paidAt)}
          value={dateFormatter(paidAt)}
        />

        <Property
          label={intl.formatMessage(translations.overview.billedAt)}
          value={datetimeFormatter(billedAt)}
        />
      </CardContent>
    </Card>
  );
};

export default InvoiceStatusSection;
